// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPhoneInfoDto } from './IPhoneInfoDto';
import {
    IPhoneInfoDtoFromJSON,
    IPhoneInfoDtoFromJSONTyped,
    IPhoneInfoDtoToJSON,
    IPhoneInfoDtoToJSONTyped,
} from './IPhoneInfoDto';
import type { IParticipantAddressInfoDto } from './IParticipantAddressInfoDto';
import {
    IParticipantAddressInfoDtoFromJSON,
    IParticipantAddressInfoDtoFromJSONTyped,
    IParticipantAddressInfoDtoToJSON,
    IParticipantAddressInfoDtoToJSONTyped,
} from './IParticipantAddressInfoDto';

/**
 * 
 * @export
 * @interface IEmployeeInfoUpdateDto
 */
export interface IEmployeeInfoUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    suffix?: string;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoUpdateDto
     */
    birth_on: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoUpdateDto
     */
    is_employee_email_preferred: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    employer_provided_email?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    employee_provided_email?: string;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeInfoUpdateDto
     */
    phone1?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeInfoUpdateDto
     */
    phone2?: IPhoneInfoDto;
    /**
     * 
     * @type {IParticipantAddressInfoDto}
     * @memberof IEmployeeInfoUpdateDto
     */
    mailing_address: IParticipantAddressInfoDto;
    /**
     * 
     * @type {IParticipantAddressInfoDto}
     * @memberof IEmployeeInfoUpdateDto
     */
    physical_address: IParticipantAddressInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    status?: IEmployeeInfoUpdateDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoUpdateDto
     */
    employment_status_effective_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoUpdateDto
     */
    hire_on?: Date;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeInfoUpdateDto
     */
    organization_id: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    payroll_group_code?: string;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoUpdateDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    custom_field1?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    custom_field2?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    custom_field3?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    custom_field4?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    custom_field5?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoUpdateDto
     */
    gender?: IEmployeeInfoUpdateDtoGenderEnum;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeInfoUpdateDtoStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeeInfoUpdateDtoGenderEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}


/**
 * Check if a given object implements the IEmployeeInfoUpdateDto interface.
 */
export function instanceOfIEmployeeInfoUpdateDto(value: object): value is IEmployeeInfoUpdateDto {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('birth_on' in value) || value['birth_on'] === undefined) return false;
    if (!('is_employee_email_preferred' in value) || value['is_employee_email_preferred'] === undefined) return false;
    if (!('mailing_address' in value) || value['mailing_address'] === undefined) return false;
    if (!('physical_address' in value) || value['physical_address'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    return true;
}

export function IEmployeeInfoUpdateDtoFromJSON(json: any): IEmployeeInfoUpdateDto {
    return IEmployeeInfoUpdateDtoFromJSONTyped(json, false);
}

export function IEmployeeInfoUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeInfoUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'birth_on': (new Date(json['birth_on'])),
        'is_employee_email_preferred': json['is_employee_email_preferred'],
        'employer_provided_email': json['employer_provided_email'] == null ? undefined : json['employer_provided_email'],
        'employee_provided_email': json['employee_provided_email'] == null ? undefined : json['employee_provided_email'],
        'phone1': json['phone1'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone1']),
        'phone2': json['phone2'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone2']),
        'mailing_address': IParticipantAddressInfoDtoFromJSON(json['mailing_address']),
        'physical_address': IParticipantAddressInfoDtoFromJSON(json['physical_address']),
        'status': json['status'] == null ? undefined : json['status'],
        'employment_status_effective_on': json['employment_status_effective_on'] == null ? undefined : (new Date(json['employment_status_effective_on'])),
        'hire_on': json['hire_on'] == null ? undefined : (new Date(json['hire_on'])),
        'organization_id': json['organization_id'],
        'payroll_group_code': json['payroll_group_code'] == null ? undefined : json['payroll_group_code'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'custom_field1': json['custom_field1'] == null ? undefined : json['custom_field1'],
        'custom_field2': json['custom_field2'] == null ? undefined : json['custom_field2'],
        'custom_field3': json['custom_field3'] == null ? undefined : json['custom_field3'],
        'custom_field4': json['custom_field4'] == null ? undefined : json['custom_field4'],
        'custom_field5': json['custom_field5'] == null ? undefined : json['custom_field5'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'gender': json['gender'] == null ? undefined : json['gender'],
    };
}

export function IEmployeeInfoUpdateDtoToJSON(json: any): IEmployeeInfoUpdateDto {
    return IEmployeeInfoUpdateDtoToJSONTyped(json, false);
}

export function IEmployeeInfoUpdateDtoToJSONTyped(value?: IEmployeeInfoUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'birth_on': ((value['birth_on']).toISOString().substring(0,10)),
        'is_employee_email_preferred': value['is_employee_email_preferred'],
        'employer_provided_email': value['employer_provided_email'],
        'employee_provided_email': value['employee_provided_email'],
        'phone1': IPhoneInfoDtoToJSON(value['phone1']),
        'phone2': IPhoneInfoDtoToJSON(value['phone2']),
        'mailing_address': IParticipantAddressInfoDtoToJSON(value['mailing_address']),
        'physical_address': IParticipantAddressInfoDtoToJSON(value['physical_address']),
        'status': value['status'],
        'employment_status_effective_on': value['employment_status_effective_on'] == null ? undefined : ((value['employment_status_effective_on']).toISOString().substring(0,10)),
        'hire_on': value['hire_on'] == null ? undefined : ((value['hire_on']).toISOString().substring(0,10)),
        'organization_id': value['organization_id'],
        'payroll_group_code': value['payroll_group_code'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'custom_field1': value['custom_field1'],
        'custom_field2': value['custom_field2'],
        'custom_field3': value['custom_field3'],
        'custom_field4': value['custom_field4'],
        'custom_field5': value['custom_field5'],
        'ssn': value['ssn'],
        'employer_employee_id': value['employer_employee_id'],
        'partner_employee_id': value['partner_employee_id'],
        'gender': value['gender'],
    };
}

